import React from 'react';
import { Link } from 'gatsby';
import plusIcon from '../../../images/icons/plus.svg';

const AddLeadButton = () => {
  return (
    <>
      <Link
        to="/app/addlead"
        className=" w-48 h-12 mr-3 mt-2 cursor-pointer text-center text-white bg-tealCol-100 rounded-md"
      >
        <div className="mx-auto inline-flex ">
          <img className="block mr-2 -mt-px " src={plusIcon} alt="+" />
          <span className="text-base py-3 block">Add Lead</span>
        </div>
      </Link>
    </>
  );
};

export default AddLeadButton;
